/* istanbul ignore file */
export * from './ProductListSeo';
